export default __webpack_public_path__ + "static/media/ElectricFans.d351ec06.jpg";